import React, { useLayoutEffect, useRef, useState } from 'react'
import Layout from "../../components/Layout/Layout";
import { SearchIcon } from '@heroicons/react/solid'
import { DocumentDownloadIcon, DotsHorizontalIcon } from '@heroicons/react/outline'


const tabs = [
    { name: 'All Transfers', href: '#', current: true },
    { name: 'Successful Transfers', href: '#', current: false },
    { name: 'Failed Transfers', href: '#', current: false },
]

const people = [
    {
        senderName: 'Lindsay Walton',
        accountOfficer: 'Ayoade Lola',
        branch: 'Abuja',
        senderBVN: '22288987902',
        beneficiaryAcct: '7689890980',
        beneficiaryName: 'Adeyanju Bimpe',
        beneficiaryBank: 'Access Bank',
        amount: '200,000',
        senderAcct: '9090909090',
        remarks: 'Tution',
        transDate: '16/08/2021',
        beneficiaryBVN: '2228989087',
        accountStatus: 'Active',
        reference: ''
    },
    {
        senderName: 'Lindsay Walton',
        accountOfficer: 'Ayoade Lola',
        branch: 'Abuja',
        senderBVN: '22288987902',
        beneficiaryAcct: '7689890980',
        beneficiaryName: 'Adeyanju Bimpe',
        beneficiaryBank: 'Access Bank',
        amount: '200,000',
        senderAcct: '9090909090',
        remarks: 'Tution',
        transDate: '16/08/2021',
        beneficiaryBVN: '2228989087',
        accountStatus: 'Inactive',
        reference: ''
    },
    {
        senderName: 'Lindsay Walton',
        accountOfficer: 'Ayoade Lola',
        branch: 'Abuja',
        senderBVN: '22288987902',
        beneficiaryAcct: '7689890980',
        beneficiaryName: 'Adeyanju Bimpe',
        beneficiaryBank: 'Access Bank',
        amount: '200,000',
        senderAcct: '9090909090',
        remarks: 'Tution',
        transDate: '16/08/2021',
        beneficiaryBVN: '2228989087',
        accountStatus: 'Inview',
        reference: ''
    },
    // More people...
]
const statusStyles = {
    Active: 'bg-green-500 text-white',
    Inview: 'bg-amber-400 text-white',
    Inactive: 'bg-orange-600 text-white',
}
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function PayRoll() {
    const checkbox = useRef()
    const [checked, setChecked] = useState(false)
    const [indeterminate, setIndeterminate] = useState(false)
    const [selectedPeople, setSelectedPeople] = useState([])

    useLayoutEffect(() => {
        const isIndeterminate = selectedPeople.length > 0 && selectedPeople.length < people.length
        setChecked(selectedPeople.length === people.length)
        setIndeterminate(isIndeterminate)
        checkbox.current.indeterminate = isIndeterminate
    }, [selectedPeople])

    function toggleAll() {
        setSelectedPeople(checked || indeterminate ? [] : people)
        setChecked(!checked && !indeterminate)
        setIndeterminate(false)
    }
    return (
        <>
            <Layout title={'Payroll'} pageTag={'transfers'} current={'/payrolls'}>
                <React.Fragment>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="sm:flex sm:items-center mt-10">
                            <div className="sm:flex-auto flex">
                                <div className="mt-1 relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        name="user"
                                        id="user"
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search customer"
                                    />
                                </div>
                                {/* <div className="mt-1 relative rounded-md shadow-sm ml-3">
                                    <select
                                        id="currency"
                                        name="currency"
                                        placeholder="Sort by"
                                        className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                    >
                                        <option>Sort by</option>
                                        <option>Name</option>
                                        <option>Account Type</option>
                                    </select>

                                </div> */}
                                <div>
                                    <div className="sm:hidden">
                                        <label htmlFor="tabs" className="sr-only">
                                            Select a tab
                                        </label>
                                        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                                        <select
                                            id="tabs"
                                            name="tabs"
                                            className="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            defaultValue={tabs.find((tab) => tab.current).name}
                                        >
                                            {tabs.map((tab) => (
                                                <option key={tab.name}>{tab.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="hidden sm:block ml-4">
                                        <nav className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200" aria-label="Tabs">
                                            {tabs.map((tab, tabIdx) => (
                                                <a
                                                    key={tab.name}
                                                    href={tab.href}
                                                    className={classNames(
                                                        tab.current ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700',
                                                        tabIdx === 0 ? 'rounded-l-lg' : '',
                                                        tabIdx === tabs.length - 1 ? 'rounded-r-lg' : '',
                                                        'group relative  min-w-max p-3 flex-1 overflow-hidden bg-white  px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10'
                                                    )}
                                                    aria-current={tab.current ? 'page' : undefined}
                                                >
                                                    <span>{tab.name}</span>
                                                    <span
                                                        aria-hidden="true"
                                                        className={classNames(
                                                            tab.current ? 'bg-indigo-500' : 'bg-transparent',
                                                            'absolute inset-x-0 bottom-0 h-0.5'
                                                        )}
                                                    />
                                                </a>
                                            ))}
                                        </nav>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                                <button
                                    type="button"
                                    className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                                >
                                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                                    Export CSV
                                </button>

                            </div>
                        </div>
                        <div className="mt-8 flex flex-col">
                            <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                    <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">

                                        <table className="min-w-full table-fixed divide-y divide-gray-300">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="relative w-12 px-6 sm:w-16 sm:px-8">
                                                        <input
                                                            type="checkbox"
                                                            className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 sm:left-6"
                                                            ref={checkbox}
                                                            checked={checked}
                                                            onChange={toggleAll}
                                                        />
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Sender's Name
                                                    </th>
                                                    <th scope="col" className="min-w-[6rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-400">
                                                        Account Officer
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400 ">
                                                        Branch
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Sender's BVN
                                                    </th>

                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Beneficiary Account Number
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Beneficiary's Name
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Beneficiary's Bank
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Amount
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Sender's Account Number
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Remarks
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Transaction Date
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Reference Number
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Beneficiary BVN
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        Status
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">

                                                    </th>


                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                {people.map((person) => (
                                                    <tr key={person.email} className={selectedPeople.includes(person) ? 'bg-gray-50' : undefined}>
                                                        <td className="relative w-6 px-6 sm:w-16 sm:px-8">
                                                            {selectedPeople.includes(person) && (
                                                                <div className="absolute inset-y-0 left-0 w-0.5 bg-indigo-600" />
                                                            )}
                                                            <input
                                                                type="checkbox"
                                                                className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 sm:left-6"
                                                                value={person.email}
                                                                checked={selectedPeople.includes(person)}
                                                                onChange={(e) =>
                                                                    setSelectedPeople(
                                                                        e.target.checked
                                                                            ? [...selectedPeople, person]
                                                                            : selectedPeople.filter((p) => p !== person)
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td
                                                            className={classNames(
                                                                'whitespace-nowrap py-4 pr-3 text-sm font-medium',
                                                                selectedPeople.includes(person) ? 'text-indigo-600' : 'text-gray-900'
                                                            )}
                                                        >
                                                            {person.senderName}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountOfficer}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.branch}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.senderBVN}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.beneficiaryAcct}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.beneficiaryName}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.beneficiaryBank}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.amount}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.senderAcct}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.remarks}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.transDate}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.reference}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.beneficiaryBVN}</td>

                                                        <td><span className={classNames(
                                                            statusStyles[person.accountStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}> {person.accountStatus}</span></td>

                                                        {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.role}</td> */}

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </Layout>
        </>
    )
}